import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
/*
  Generated class for the CultpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CultoProvider {
  baseUrl = environment.API_URL;
  private instituicaoFiltragem = null
  constructor(public http: HttpClient) {
    console.log('Hello CultpProvider Provider');
  }

  getCultos() {
    return this.http.get<any>(this.baseUrl + '/culto/buscar').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerPessoa(pessoa) {
    return this.http.post<any>(this.baseUrl + '/culto/remover-pessoa', { pessoa: pessoa }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getCultosFiltro(filtro) {
    return this.http.post<any>(this.baseUrl + '/culto/buscar-filtro', filtro).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getNotificacoes() {
    return this.http.get<any>(this.baseUrl + '/culto/notificacoes').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  confirmarPresenca(culto) {
    return this.http.post<any>(this.baseUrl + '/culto/confirmar-presenca', culto).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getCultoAgenda(idCulto, dataInicio, idCultoAgenda) {
    return this.http
      .get<any>(this.baseUrl + '/culto/get-culto-agenda', {
        params: {
          idCulto: idCulto,
          dataInicio: dataInicio,
          idCultoAgenda: idCultoAgenda,
          esconderEncarregados: 'true',
        },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getPresencaLiderados(idCulto) {
    return this.http
      .post<any>(this.baseUrl + '/culto/presenca-liderados', {
        idCulto: idCulto,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getTipos() {
    return this.http.get<any>(this.baseUrl + '/culto/culto-tipos').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getPresencaEncarregados(idCulto) {
    return this.http
      .post<any>(this.baseUrl + '/culto/presenca-encarregados', {
        idCulto: idCulto,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarPresencas(idCulto, dataInicio, id, liderados) {
    var vinculados = new Array();

    liderados.forEach((element) => {
      if (element.presenca == true) {
        vinculados.push({ idPessoa: element.idPessoa });
      }
    });

    return this.http
      .post<any>(this.baseUrl + '/culto/save-presencas', {
        idCulto: idCulto,
        dataInicio: dataInicio,
        id: id,
        vinculados: vinculados,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarPresenca(idCulto, dataInicio, id, pessoa = null, canUpdate = true) {
    return this.http
      .post<any>(this.baseUrl + '/culto/save-presenca', {
        idCulto: idCulto,
        dataInicio: dataInicio,
        id: id,
        pessoa: pessoa,
        canUpdate: canUpdate,
      })
      .map((data) => {
        return data;
      });
  }

  salvarPresencaEncarregado(idCulto, dataInicio, id, pessoa) {
    return this.http
      .post<any>(this.baseUrl + '/culto/save-encarregado', {
        idCulto: idCulto,
        dataInicio: dataInicio,
        id: id,
        encarregado: pessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  setPresencaBarcode(idPessoa, idCultoAgenda) {
    return this.http
      .post<any>(this.baseUrl + '/culto/presenca-encarregado-barcode', {
        idPessoa: idPessoa,
        idCultoAgenda: idCultoAgenda,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getEncarregados(filtro, pag, idCultoAgenda) {
    return this.http
      .get<any>(this.baseUrl + '/culto/buscar-encarregados', {
        observe: 'response',
        params: {
          expand: 'pessoa,pessoaFuncoesEspec',
          page: pag.currentPage,
          'per-page': '10',
          q: filtro.q,
          idCultoAgenda: idCultoAgenda,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          encarregados: data.body,
          pagination: pag,
        };
      });
  }

  salvarPermissaoLeituraQrCode(idEscalaFuncaoPessoa, permissaoLeituraQrcode = false) {
    return this.http
      .post<any>(this.baseUrl + '/culto/salvar-permissao-leitura-qr-code', {
        idEscalaFuncaoPessoa: idEscalaFuncaoPessoa,
        permissaoLeituraQrcode: permissaoLeituraQrcode,
      })
      .map((data) => {
        return data;
      });
  }

  setInstituicaoFiltragem(instituicao) {
    this.instituicaoFiltragem = instituicao;
  }

  getInstituicaoFiltragem() {
    return this.instituicaoFiltragem;
  }
}



// WEBPACK FOOTER //
// ./src/providers/culto/culto.ts